import { useState } from 'react';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { toast } from 'sonner';
import { onboardingReviewAPI } from '../../lib/onboardingReviewAPI';
import { EngagementFeesEditor, initialEngagementFees, toFeePayload } from './EngagementFeesEditor';

export const MemberInviteDialog = ({ clientId, member, onClose }) => {
  const [fees, setFees] = useState(initialEngagementFees(['individual_tax_return']));
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);

  const send = async () => {
    if (fees.types.length === 0) { toast.error('Select at least one engagement type'); return; }
    setSending(true);
    try {
      const res = await onboardingReviewAPI.inviteMember(clientId, member.id, {
        base_url: window.location.origin, email: email || null, ...toFeePayload(fees),
      });
      toast.success(`Registration link sent to ${res.data.to}`);
      onClose();
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : 'Failed to send link');
    } finally { setSending(false); }
  };

  return (
    <Dialog open={!!member} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl" data-testid="member-invite-dialog">
        <DialogHeader>
          <DialogTitle>Send registration link — {member?.display_name}</DialogTitle>
          <DialogDescription>Choose the engagement types and proposed fees for this entity.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label>Email (optional — defaults to the member's primary contact)</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="member-invite-email" />
          </div>
          <EngagementFeesEditor value={fees} onChange={setFees} />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="member-invite-cancel">Cancel</Button>
          <Button onClick={send} disabled={sending} data-testid="member-invite-send">{sending ? 'Sending…' : 'Send link'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
